import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  API_MANAGEMENT,
  apiKeysAdapter,
  ApiKeysState,
  ApiManagementState,
  scopeGroupsAdapter,
} from '@modules/api-management/store/reducer/api-managment.reducer';

export const getApiManagementState = createFeatureSelector<ApiManagementState>(API_MANAGEMENT);

export const getApiKeysState = createSelector(getApiManagementState, (state) => state?.apiKeys);

export const getApiKeysLoading = createSelector(
  getApiKeysState,
  (state: ApiKeysState) => state?.loading,
);

export const getPaginationApiKey = createSelector(
  getApiKeysState,
  (state: ApiKeysState) => !!state && state.pagination,
);

export const { selectAll: getApiKeysAll } = apiKeysAdapter.getSelectors(getApiKeysState);

export const getScopeGroupsState = createSelector(
  getApiManagementState,
  (state) => state?.scopeGroups,
);

export const { selectAll: getScopeGroupsAll } =
  scopeGroupsAdapter.getSelectors(getScopeGroupsState);
